<template>
  <div class="d-flex">
    <navigator :flag="navFlag" />
    <OnboardingWrapper class="dashboard-wrapper">
      <div class="dashboard-page">
        <div class="title-header">
          <h1 v-if="userType == 0">Dashboard</h1>
        </div>

        <div class="top-sections">
          <div class="p-1">
            <div class="p-headers-container">
              <div class="p-headers p-headers-shifted" id="assignments-section">
                <span>My Assignments</span>
                <div class="header-search-wrapper">
                  <b-form-input 
                    v-model="searchTerm" 
                    placeholder="Search your assignments..." 
                    class="assignments-search-bar"
                  ></b-form-input>
                </div>
              </div>
            </div>

            <div class="p-1-1">
              <div class="p-subheaders">Assignments Due</div>

              <div v-if="filteredProjects.length == 0" class="dashboard-no-project">
                <img src="../../assets/Not Found.png" class="dashboard-no-project-img" />
                <div class="dashboard-no-project-txt">No projects Found</div>
              </div>

              <div v-else-if="userType == 0" class="assignments-scroll-container" id="assignments-container">
                <ProjectCardsTester :projects="filteredProjects" @open="openPopup" />
              </div>

              <div class="p-1-2">
                <div class="p-subheaders">New Assignments</div>

                <div v-if="filteredProjects.length == 0" class="dashboard-no-project">
                  <img src="../../assets/Not Found.png" class="dashboard-no-project-img" />
                  <div class="dashboard-no-project-txt">No projects Found</div>
                </div>

                <div v-else class="assignments-scroll-container"></div>
              </div>
            </div>
          </div>

          <div v-if="userType == 0" class="p-2">
            <div class="messages-container">
              <div class="p-headers" id="messages-section">Messages</div>
              <div class="messages-scroll">
                <MessageContacts
                  :contacts="contacts"
                  :systemPayloadList="visibleNotifications"
                  @open-chat="openChatPanel"
                  @open-system-popup="openSystemPopup"
                />
              </div>
            </div>
          </div>
        </div>

        <div v-if="userType == 0" class="p-3">
          <div class="p-headers" id="discover-section">New Projects!</div>
          <div class="p-3-content">
            <div class="assignments-scroll-container scroll-active" id="discover-container">
              <ProjectCardTesterDiscover :projects="allProjects" />
            </div>
          </div>
        </div>

        <div v-if="userType == 0" class="view-details-popup">
          <GameDetailsPopup ref="viewDetailsPopupRef" :popupVisible="viewDetailsPopup" @close="closePopup" />
        </div>
      </div>

      <MessagePanel ref="messagePanel" :contacts="chatContacts" :userType="this.userType"/>
      <SystemNotificationPopup
        v-if="showSystemPopup"
        :notifications="currentNotification"
        @mark-read="markNotificationRead"
        @close="showSystemPopup = false"
      />
    </OnboardingWrapper>
  </div>
</template>

<script>
import Chat from '../../Firestore/Chat.js';
import ProjectCardsTester from './ProjectCardsTester.vue';
import ProjectCardsDev from './ProjectCardsDev.vue';
import navigator from '../layout/NavBarNew.vue';
import Loading from '../loading/index.vue';
import GamesObject from '../../Firestore/GamesObject.js';
import ProjectCardTesterDiscover from './ProjectCardTesterDiscover.vue';
import GameDetailsPopup from '../game-detail/GameDetail-TestersPopup.vue';
import MessageContacts from '../messagebox/contactlist.vue';
import MessagePanel from '../messagebox/developer-messagepanel.vue';
import OnboardingWrapper from '../onboarding/OnboardingWrapper.vue';
import { onboardingService } from '@/services/OnboardingService';
import { notificationTypes } from '../../util/notificationTypes.js';
import SystemNotificationPopup from '../messagebox/SystemNotificationPopup.vue';
import { subscribeTesDevNotifications } from "../../Firestore/NotificationDevTes.js";
import { initializePageOnboarding } from '@/services/onboardingConfigs';
import systemNotifications from '../../mixins/systemNotifications.js';
import { db, auth } from "../../db.js"
import UserObject from "../../Firestore/UserObject.js"

export default {
  name: 'Dashboard',
  mixins: [systemNotifications],
  components: {
    navigator,
    ProjectCardsDev,
    ProjectCardsTester,
    Loading,
    ProjectCardTesterDiscover,
    GameDetailsPopup,
    MessageContacts,
    MessagePanel,
    OnboardingWrapper,
    SystemNotificationPopup,
  },
  data: function() {
    return {
      totalGames: 0,
      isLoading: false,
      navFlag: 0,
      userType: window.localStorage.getItem('userType') ? parseInt(window.localStorage.getItem('userType')) : -1,
      searchTerm: '',
      projects: [],
      allProjects: [],
      viewDetailsPopup: false,
      contacts: [],
      conversations: [],
      systemNotifications: [],
      showSystemPopup: false,
      currentNotification: null,
      unsubscribeNotifications: null,
    };
  },
  computed: {
    filteredProjects: {
      get: function() {
        var self = this;
        return this.projects.filter(function(proj) {
          return proj.gameName.toLowerCase().indexOf(self.searchTerm.toLowerCase()) !== -1;
        });
      },
      set: function(projs) { return projs; },
    },
  },
  mounted: async function() {
    try{
      const uid = auth.currentUser.uid;
      const userDoc = await db.collection("User").doc(uid).get();
      console.log(uid);
      if (!userDoc.data().settings){await UserObject.setDefaultSettings(uid);}
    }catch(err){
      throw new Error("Failed to set default settings", { cause: err });
    }

    if (window.localStorage.getItem('userType')) {
      this.userType = parseInt(window.localStorage.getItem('userType'));
    } else {
      this.$router.push({ name: 'login' });
      return;
    }
    this.getProjects();
    this.getAllProjects();
    this.loadUserConversations();
    if (this.userType === 0) {
      var testId = localStorage.getItem("userId");
      var self = this;
      if (testId) {
        this.unsubscribeNotifications = subscribeTesDevNotifications(
          testId,
          this.onSystemNotification,
          function(id) {
            self.systemNotifications = self.systemNotifications.filter(function(n) { return n.firebaseId !== id; });
          }
        );
      }
      this.$nextTick(function() {
        initializePageOnboarding('dashboard', self.userType, onboardingService, self.$store);
      });
    }
  },
  methods: {
    loadUserConversations: function() {
      var userId = window.localStorage.getItem('userId');
      var self = this;
      Chat.getUserConversations(userId, function(result) {
        if (result.success) {
          self.conversations = result.data.filter(function(c) { return c.isAdminChat !== true; });
          self.transformConversationsToContacts();
        }
      });
    },
    onSystemNotification: function(data) {
      this.systemNotifications.push(Object.assign({}, data, {
        id: data.firebaseId,
        unread: data.unread,
        timestamp: data.timestamp && data.timestamp.toDate ? data.timestamp.toDate() : new Date(data.timestamp),
      }));
      this.transformConversationsToContacts();
    },
    transformConversationsToContacts: function() {
      var currentUserId = window.localStorage.getItem('userId');
      var contactsArray = [];
      var visible = this.visibleNotifications;
      var unread = visible.length;
      if (visible.length > 0) {
        var lastNoti = visible[0];
        contactsArray.push({
          id: '__system_notification__',
          type: 'system',
          name: 'Notifications',
          avatar: require('@/assets/notif_icon.png'),
          lastMessage: notificationTypes[lastNoti.type].getMessage(lastNoti),
          lastMessageAt: new Date(9999999999999),
          unreadCount: unread,
        });
      }
      var self = this;
      var promises = this.conversations.map(function(conversation) {
        var otherUserId = conversation.participants.filter(function(id) { return id !== currentUserId; })[0];
        if (otherUserId) {
          return Chat.getUserInfo(otherUserId).then(function(userResult) {
            if (userResult.success) {
              var userData = userResult.data;
              contactsArray.push({
                id: otherUserId,
                conversationId: conversation.conversationId,
                type: 'user',
                name: userData.nickName || userData.userName || 'Unknown User',
                avatar: userData.img || require('../../assets/avator_example.jpg'),
                lastMessage: conversation.lastMessage || 'No messages yet',
                lastMessageAt: conversation.lastMessageAt,
                unreadCount: (conversation.unreadCount && conversation.unreadCount[currentUserId]) || 0,
              });
            }
          })
          .catch(function() {});
        }
      });
      Promise.all(promises).then(function() {
        contactsArray.sort(function(a, b) {
          var getTime = function(ts) {
            if (!ts) return 0;
            if (ts.toDate) return ts.toDate().getTime();
            if (ts instanceof Date) return ts.getTime();
            return 0;
          };
          return getTime(b.lastMessageAt) - getTime(a.lastMessageAt);
        });
        self.contacts = contactsArray;
      });
    },
    openChatPanel: function(contact) {
      if (!this.$refs.messagePanel) return;
      this.$refs.messagePanel.openChatWithContact(contact);
    },
    getProjects: function() {
      var userId = window.localStorage.getItem('userId');
      var self = this;
      if (this.userType == 0) {
        GamesObject.getTesterProjects(userId).then(function(res) { self.projects = res.data; });
      } else if (this.userType == 1) {
        GamesObject.getDevProjects(userId).then(function(res) { self.projects = res.data; });
      }
    },
    getAllProjects: function() {
      var self = this;
      if (this.userType == 0) {
        GamesObject.getAllProjects().then(function(res) { self.allProjects = res.data; });
      }
    },
    openPopup: function() {
      this.viewDetailsPopup = true;
      var self = this;
      this.$nextTick(function() {
        if (self.$refs.viewDetailsPopupRef && self.$refs.viewDetailsPopupRef.updatePopup) {
          self.$refs.viewDetailsPopupRef.updatePopup();
        }
      });
    },
    closePopup: function() { this.viewDetailsPopup = false; }
  }
};
</script>

<style scoped>
* { box-sizing: border-box; }

.dashboard-page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  background-color: #eeeeee;
  overflow-x: hidden;
}

.title-header {
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
  width: 100%;
  box-shadow: 0 4px 10px -6px grey;
  z-index: 10;
}

.title-header h1 {
  color: #ff7222;
  font-weight: bold;
  font-size: 2rem;
  margin: 0;
}

.top-sections {
  display: flex;
  flex-direction: row;
  gap: 20px;
  padding: 20px;
  width: 100%;
}

.p-1, .p-2, .p-3 {
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 25px;
}

.p-1 { flex: 1 1 65%; overflow: hidden; }
.p-2 { flex: 1 1 35%; max-width: 400px; min-width: 300px; overflow: hidden; }
.p-3 { margin: 0 20px 20px 20px; width: calc(100% - 40px); overflow: hidden; }

/* Modified Headers Container for Search bar alignment */
.p-headers {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  font-size: 1.8rem;
  font-weight: bold;
  color: #ff7222;
  border-bottom: 2px solid #ff7222;
  margin-top: 10px; 
  margin-bottom: 20px;
  padding-bottom: 10px;
  width: 100%;
  padding-right: 10px;
}

.p-headers-shifted {
  margin-left: 15px;
  width: calc(100% - 15px);
}

/* Specific styling for the inline search bar */
.header-search-wrapper {
  width: 250px;
}

.assignments-search-bar {
  font-size: 0.9rem !important;
  font-weight: normal !important;
  border-radius: 10px !important;
  background-color: #f2f2f2 !important;
  border: 1px solid #ddd !important;
  padding: 5px 12px !important;
  height: 35px !important;
  transition: 0.2s ease;
}

.assignments-search-bar:focus {
  border-color: #ff7222 !important;
  background-color: white !important;
  box-shadow: 0 0 0 0.2rem rgba(255, 114, 34, 0.1) !important;
}

.p-subheaders {
  font-size: 1.3rem;
  font-weight: bold;
  color: #3f3e3e;
  margin: 15px 0 10px 15px;
}

.assignments-scroll-container {
  display: block; 
  width: 100%;
  overflow-x: auto !important;
  overflow-y: hidden;
  padding-bottom: 15px;
}

.assignments-scroll-container >>> .projects-container, 
.assignments-scroll-container >>> .project-cards-wrapper,
.assignments-scroll-container >>> .row {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  gap: 20px;
  width: max-content;
}

.assignments-scroll-container >>> .project-card,
.assignments-scroll-container >>> .card-item {
  flex: 0 0 auto !important;
}

.messages-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.messages-scroll {
  flex: 1;
  overflow-y: auto;
  min-height: 400px;
}

.assignments-scroll-container::-webkit-scrollbar { height: 8px; }
.assignments-scroll-container::-webkit-scrollbar-thumb { background: #ff7222; border-radius: 10px; }
.assignments-scroll-container::-webkit-scrollbar-track { background: #f1f1f1; }

@media screen and (max-width: 1200px) {
  .top-sections { flex-direction: column; }
  .p-headers-shifted { margin-left: 0; width: 100%; }
  .p-headers { flex-direction: column; align-items: flex-start; gap: 10px; }
  .header-search-wrapper { width: 100%; }
}
</style>


// WEBPACK FOOTER //
// src/components/game-dashboard/Dashboard.vue